// Dialog mode enum - USE ENUM, NOT STRING LITERALS
export enum DialogMode {
  Create = 'create',
  Edit = 'edit',
}
